module.exports = __webpack_public_path__ + "img/C1B3A1_F6EEE5_E1D7C7_ECE4D3-256px.c8aed5ae.png";